import React, { Component } from "react";
import { Link, withRouter  } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import {toast,Toaster } from 'react-hot-toast';
import classnames from "classnames";
const toastStyles = {
    style: {
      borderRadius: '10px',
      background: '#fff',
      color: '#000',
    },
  }
class Register extends Component {

    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            password: "",
            password2: "",
            message: "",
            referralBy:"",  
            passwordnew:"",
            statusB:true,
            type:"password",
            typePassConfm:"password",
            errors: {},
			term_condition:false
        };
        
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });            
        }       
        if (nextProps.auth.reg != undefined
            && nextProps.auth.reg.data != undefined
            && nextProps.auth.reg.data.message != undefined
            && nextProps.auth.reg.data.status) {
                toast.success(nextProps.auth.reg.data.message,toastStyles);
                // toast( nextProps.auth.reg.data.message, {
                //     position: toast.POSITION.TOP_CENTER
                //   });
             this.setState({
                message: nextProps.auth.reg.data.message,
                name:"",
                email:"",
                password:"",
                password2:"",
                referralBy:"",
                errors: {
                   email: ""
                }
            });
            // setTimeout(function() {
            //     // add class
            //     const element = document.getElementById("SignIn");
            //     element.classList.add("active");
            //     const element1 = document.getElementById("signintab");
            //     element1.classList.add("show");
            //     element1.classList.add("active");
            //     // remove class
            //     const element2 = document.getElementById("SignUp");
            //     element2.classList.remove("active");
            //     const element3 = document.getElementById("signuptab");
            //     element3.classList.remove("active");
            //     element3.classList.remove("show");

            // }, 500);          
        }else{
            if(nextProps.auth.reg.data != undefined){
                this.setState({errors:{message:nextProps.auth.reg.data.message,email:nextProps.auth.reg.data.email,password:nextProps.auth.reg.data.password,password2:nextProps.auth.reg.data.password2}});
            }
            
        }        
    }
    componentDidMount() {
		if(this.props.match.params.refer!==undefined){			
			this.setState({referralBy:this.props.match.params.refer})
		}
    }
    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
        this.setState({
            errors: {
                name: "",
                email: "",
                password: "",
                password2: "",
                referralBy:"",
				message:""
            }
        });
		if(e.target.id=="name"){
            const strongRegexName = new RegExp(/^[a-zA-Z0-9]*$/);
            const onlynumeric = new RegExp(/^[0-9\b]+$/);
            var testName = strongRegexName.test(e.target.value);
            var testOnlyNumric = onlynumeric.test(e.target.value);
     
            if (!testName || testOnlyNumric){
                this.setState({ errors: {name: "Only use Alphanumeric Characters without Space"}});  
            }
            if(e.target.value.length>10){
                this.setState({ errors: {name: "Only use 10 Characters"}});
            }			
        }
        if(e.target.id=="password"){
            const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            var test = strongRegex.test(e.target.value);
     
            if (test) {         
                this.setState({ passwordnew: "strong password",
                statusB:false});
            }else{
                this.setState({ errors: {password: "Min 8 characters(Including 1 Upper case, 1 Numeric value, 1 Special symbol)"}});   
            }
        }
        if(e.target.id=="password2"){
            if(e.target.value !== this.state.password){
                this.setState({ errors: {password2: "Passwords must match"}}); 
            }
        }
}


	handleChange=()=>{
		this.setState({
		  term_condition: !this.state.term_condition
		});
		if(!this.state.term_condition){
			this.setState({
				errors: {
					term_condition: ""
				}
			});
		}
		else {
			this.setState({ errors: {term_condition: "Please accept Term and conditions"}}); 
		}
	  }
  
    onSubmit = e => {
        e.preventDefault();
		
		const strongRegexNameCk = new RegExp(/^[a-zA-Z0-9]*$/);
        const onlynumeric = new RegExp(/^[0-9\b]+$/);
		var testNameCk = strongRegexNameCk.test(this.state.name);
        var testOnlyNumric = onlynumeric.test(this.state.name);
		if (!testNameCk || testOnlyNumric){            
			this.setState({ errors: {name: "Only use Alphanumeric Characters without Space"}});  
			return false;
		}
		if(this.state.name.length>10){
            this.setState({ errors: {name: "Only use 10 Characters"}});
            return false;
        }
		if (!this.state.term_condition){
			this.setState({ errors: {term_condition: "Please accept Term and conditions"}});  
			return false;
		}
		
		
		const strongRegexSubmit = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
		var testSubmit = strongRegexSubmit.test(this.state.password);
 
		if (!testSubmit) {         
			this.setState({ errors: {password: "Min 8 characters(Including 1 Upper case, 1 Numeric value, 1 Special symbol)"}}); 
			return false;
		}
        
		
        if(this.state.password==this.state.password){
             const newUser = {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
      
            password2: this.state.password2,
            referralBy: this.state.referralBy,
        };
        let res = this.props.registerUser(newUser, this.props.history);
        }else{
          this.setState({ errors: {password2: "Passwords must match"}}); 
        }
    }
    eyeFucntion= e =>{
        if(this.state.type=="password"){
         this.setState({type:"text"});
        }else{
         this.setState({type:"password"});
        }
    }
    eyeConfmPassFucntion= e =>{
        if(this.state.typePassConfm=="password"){
         this.setState({typePassConfm:"text"});
        }else{
         this.setState({typePassConfm:"password"});
        }
    }
   
    render() {
        // alert(this.state.message);
        const { errors } = this.state;
        return (
            <div className="tab-pane" id="SignUp">
                {/* <span className="text-danger text-center f12">{errors.message}</span> */}
                {/* <span className="text-success">{this.state.message}</span> */}
            {/* <form noValidate onSubmit={this.onSubmit}>
                <div className="form-group">
                    <input onChange={this.onChange} value={this.state.name}  name="name" className="form-control" placeholder="Username" id="name" type="text" error={errors.name}

                    />
                    <span className="text-danger f12">{errors.name}</span>
                </div>
                
                    <div className="form-group">
                        <input onChange={this.onChange} value={this.state.email}  className="form-control" placeholder="Email" id="email" type="text" error={errors.email}/>
                        <span className="text-danger f12">{errors.email}</span>
                    </div>

                    <div className="form-group position-relative">
                        <input onChange={this.onChange} value={this.state.password} error={errors.password}
                            id="password" type={this.state.type=='password'?"password":"text"} placeholder="Password" className="form-control" autoComplete="off"
                        />
                        <i className= {this.state.type=='password'?"las la-low-vision eyestyle":"las la-eye eyestyle"} onClick={this.eyeFucntion} ></i>
                        <span className="text-danger f12">{errors.password}</span>
                         <span className="text-success f12">{errors.passwordnew}</span>
                    </div>
                    <div className="form-group position-relative">
                        <input onChange={this.onChange} value={this.state.password2} id="password2" type={this.state.typePassConfm=='password'?"password":"text"} 
                            placeholder="Confirm password"  className="form-control" autoComplete="off"/>
                            <i className= {this.state.typePassConfm=='password'?"las la-low-vision eyestyle":"las la-eye eyestyle"} onClick={this.eyeConfmPassFucntion} autoComplete="off"></i>
                        <span className="text-danger f12">{errors.password2}</span>
                    </div>

                    <div className="form-group">
                        <input onChange={this.onChange} value={this.state.referralBy}  className="form-control" autoComplete="off" placeholder="Referral" id="referralBy" type="text" error={errors.referralBy}/>
                    </div>
					
					 <div className="form-group" style={{lineHeight:'12px'}}>
                        <input onChange={this.handleChange} required value={this.state.term_condition}  className="form-control" autoComplete="off" defaultChecked={this.state.term_condition} id="term_condition" type="checkbox" error={errors.term_condition}  style={{width:'6%',float:'left'}}
	
                        />
						I Agree all <Link to="/term-and-condition" target="_blank">terms and conditions</Link>
						<br/>
						<br/>
						<span className="text-danger f12">{errors.term_condition}</span>
                    </div>
                  
                    <div className="form-group">
                        <button className="btn w100 btn_man" disabled={this.state.statusB} >Sign up</button>
                    </div>
                </form> */}
            </div>
        );
    }
}

Register.propTypes = {
    registerUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { registerUser }
)(withRouter(Register));